import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import {
  ButtonClean,
  ButtonFilter,
  ContentFilters,
  FieldsContainer,
} from "./AdminEventsFilters.styled";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};
const AdminEventsFilters = ({
  countries,
  cities,
  categoriesList,
  setDataFilter,
  handleChangeSelectCountry,
  handleCleanFilters,
  FilterEvents,
  rCities,
  showCategory = true,
}) => {
  const rCountries = useRef();
  const rCategory = useRef();
  const rFinalDate = useRef();
  const rInicialDate = useRef();
  const [onStartFilter, setOnStartFilter] = useState(null);
  const [onEndFilter, setOnEndFilter] = useState(null);

  let changeDataFilter = (isClean) => {
    let filter = {
      inicialDate: isClean ? null : onStartFilter,
      finalDate: isClean ? null : onEndFilter,
      country: rCountries?.current?.state?.ariaSelection?.value?.value,
      city: rCities?.current?.state?.ariaSelection?.value?.value,
      category: rCategory?.current?.state?.ariaSelection?.value?.value,
      name: "",
      eventType: "",
    };
    setDataFilter(filter);
  };

  let cleanFilters = () => {
    rCities.current.clearValue();
    rCountries.current.clearValue();
    rCategory.current.clearValue();
    setOnStartFilter(null);
    setOnEndFilter(null);
    rInicialDate.current.value = "";
    rFinalDate.current.value = "";
    changeDataFilter(true);
    handleCleanFilters();
  };

  useEffect(() => {
    rCities.current.state.ariaSelection = [];
  }, [cities]);

  return (
    <FieldsContainer>
      <div className="field-div">
        <Select
          styles={customStyles}
          placeholder="Country"
          ref={rCountries}
          options={countries}
          onChange={handleChangeSelectCountry}
          onBlur={() => changeDataFilter()}
        />
      </div>
      <div className="field-div">
        <Select
          styles={customStyles}
          placeholder="City"
          ref={rCities}
          options={cities}
          onBlur={() => changeDataFilter()}
        />
      </div>
      {showCategory && (
        <div className="field-div">
          <Select
            styles={customStyles}
            placeholder="Category"
            ref={rCategory}
            options={categoriesList}
            onBlur={() => changeDataFilter()}
          />
        </div>
      )}
      <div className="field-div ">
        <Form.Control
          type="date"
          required={false}
          ref={rInicialDate}
          onChange={(e) => {
            if (e.currentTarget.value !== "") {
              setOnStartFilter(new Date(e.currentTarget.value).toJSON());
            }
          }}
          onBlur={() => changeDataFilter()}
        />
      </div>
      <div className="field-div">
        <Form.Control
          type="date"
          required={false}
          ref={rFinalDate}
          onChange={(e) => {
            if (e.currentTarget.value !== "") {
              setOnEndFilter(
                new Date(
                  new Date(e.currentTarget.value).setUTCHours(23, 59, 59)
                ).toJSON()
              );
            }
          }}
          onBlur={() => changeDataFilter()}
        />
      </div>
      <ContentFilters>
        <ButtonClean onClick={() => cleanFilters()}>Reset</ButtonClean>
        <ButtonFilter onClick={() => FilterEvents()}>Apply</ButtonFilter>
      </ContentFilters>
    </FieldsContainer>
  );
};
export default AdminEventsFilters;
